<template>
  <div class="bullets">
    <div class="bullet" id="texto0">
      <div class="inner-bullet">
        La violencia homicida contra los adultos mayores ha sido una constante
        en los últimos nueve años en el país. En 2017 y 2020 se reportaron las
        tasas más altas a nivel nacional: 13 homicidios por cada 100 mil
        mexicanos en ese rango de edad.
      </div>
    </div>
    <div class="bullet" id="texto1">
      <div class="inner-bullet">
        <span class="highlight-colima">Colima</span> es un punto de alarma.
        Entre 2015 y 2023 su tasa de homicidios de adultos mayores creció
        drásticamente, en 2023 fue cuatro veces más alta que la de todo el país.
        Esta entidad tiene cifras de asesinatos que no se presentan en ninguna
        otra zona de México.
      </div>
    </div>
    <div class="bullet" id="texto2">
      <div class="inner-bullet">
        Los asesinatos contra la población adulta mayor que se registraron en
        <span class="highlight-bajacalifornia">Baja California</span> tuvieron
        su mayor pico en 2020, esto concuerda con las cifras de violencia que se
        expandieron por México, ya que hubo otros 13 estados que reportaron
        tasas por encima de la nacional.
      </div>
    </div>
    <div class="bullet" id="texto3">
      <div class="inner-bullet">
        En 2023 <span class="highlight-morelos">Morelos</span> se posicionó como
        la segunda entidad con la mayor tasa de asesinatos de adultos mayores:
        30 por cada 100 mil. La violencia contra esta población regresó a los
        patrones de 2015 cuando también tuvieron una de las tasas más altas de
        todo el país.
      </div>
    </div>
  </div>
  <div class="contenedor-general" id="contenedor-general">
    <div class="grafico" id="grafico-gral">
      <!--       <h3>{{ seleccion }}</h3> -->
      <div class="contenedor-grafico-tasas" id="contenedor-grafico-tasas">
        <h1></h1>
        <svg
          id="svg_lineas"
          class="svg-lineas"
          :width="ancho + margenes.derecha + margenes.izquierda"
          :height="alto_svg"
        >
          <g
            class="eje-x"
            :transform="`translate(${margenes.izquierda},${
              margenes.arriba + alto
            })`"
          ></g>
          <g
            class="eje-y"
            :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
          ></g>
          <g
            class="grupo-lineas"
            :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
          ></g>
          <g
            class="grupo-nombres"
            :transform="`translate(${margenes.izquierda},${margenes.arriba})`"
          ></g>
        </svg>
        <p class="pie">
          <span class="fuente">Nota</span>: Se consideraron los homicidios
          ocurridos en las distintas entidades federativas según el año de
          ocurrencia.<br />
          <span class="fuente">Fuente</span>: Elaboración propia a partir de las
          Estadística de Defunciones Registradas del INEGI y las proyecciones de
          población a mitad de año del CONAPO, 1950-2070.
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import * as d3 from "d3";
import * as ScrollMagic from "scrollmagic";
import { onMounted, onUnmounted, ref, watch } from "vue";
import datos from "../assets/tasas_estatales.json";

const seleccion = ref("Nacional");
const data = ref(datos);

const color_dict = ref({
  Colima: "#D82B1E",
  Morelos: "#6645AA",
  "Baja California": "#03244E",
  nacional: "#FD7200",
  normal: "grey",
});
const contenedor_svg = ref();
const svg = ref();
const ancho = ref(0);
const alto_svg = ref(500);
const alto = ref(0);
const margenes = ref({
  derecha: 20,
  izquierda: 65,
  abajo: 35,
  arriba: 20,
});

const grupo_lineas = ref();
const escalaX = ref();
const escalaY = ref();
const eje_X = ref();
const eje_Y = ref();
const texto_x = ref();
const texto_y = ref();
const formatoTemporal = ref(d3.timeParse("%Y"));

const grupo_nombres = ref();
// init controllers
const controlador_grafico = new ScrollMagic.Controller();
const controlador_texto0 = new ScrollMagic.Controller();
const controlador_texto1 = new ScrollMagic.Controller();
const controlador_texto2 = new ScrollMagic.Controller();
const controlador_texto3 = new ScrollMagic.Controller();

onMounted(() => {
  contenedor_svg.value = document.getElementById(`contenedor-grafico-tasas`);
  svg.value = d3.select(`svg#svg_lineas`);
  eje_X.value = svg.value.select("g.eje-x");
  eje_Y.value = svg.value.select("g.eje-y");
  grupo_lineas.value = svg.value.select("g.grupo-lineas");
  texto_x.value = svg.value.append("text").attr("text-anchor", "middle");
  texto_y.value = svg.value.append("text").attr("text-anchor", "middle");
  grupo_nombres.value = svg.value.select("g.grupo-nombres");

  dimensionandingLineas();
  graficaLineas();

  // Esta scene se encarga de dejar fijo el gráfico mientras lo demás scrollea
  new ScrollMagic.Scene({
    triggerElement: "#contenedor-grafico-tasas",
    triggerHook: "onLeave", // show, when scrolled 10% into view
    duration: "290%",
    offset: -window.innerHeight * 0.04,
  })
    .setPin("#contenedor-grafico-tasas")
    .addTo(controlador_grafico); // assign the scene to the controller

  // Esta scene se encarga de animar y hacer aparecer el primer
  // cuando el texto, es decir, el introductorio
  new ScrollMagic.Scene({
    triggerElement: "#texto0",
    triggerHook: "onCenter", // show, when scrolled 10% into view
    duration: "100%",
  })
    .on("enter", function () {
      seleccion.value = "";
    })
    .setClassToggle("#texto0", "visible")
    .addTo(controlador_texto0);

  // Esta scene se encarga de cambiar colorear la linea de Colima
  // cuando el texto de Colima entra en la pantalla
  new ScrollMagic.Scene({
    triggerElement: "#texto1",
    triggerHook: "onCenter",
    duration: "100%",
    reverse: true,
    //offset: 50,
  })
    .on("enter", function () {
      seleccion.value = "Colima";
    })
    .setClassToggle("#texto1", "visible") // add class to reveal
    .addTo(controlador_texto1); // assign the scene to the controller

  // Esta scene se encarga de cambiar colorear la linea de Baja California
  // cuando el texto de Baja California entra en la pantalla
  new ScrollMagic.Scene({
    triggerElement: "#texto2",
    triggerHook: "onCenter",
    duration: "100%",
    reverse: true,
    //offset: 50,
  })
    .on("enter", function () {
      seleccion.value = "Baja California";
    })
    .setClassToggle("#texto2", "visible")
    .addTo(controlador_texto2);

  // Esta scene se encarga de cambiar colorear la linea de Morelos
  // cuando el texto de Morelos entra en la pantalla
  new ScrollMagic.Scene({
    triggerElement: "#texto3",
    triggerHook: "onCenter",
    duration: "100%",
    reverse: true,
  })
    .on("enter", function () {
      seleccion.value = "Morelos";
    })
    .setClassToggle("#texto3", "visible")
    .addTo(controlador_texto3);

  window.addEventListener("resize", reescalanding);
});
onUnmounted(() => {
  window.removeEventListener("resize", reescalanding);
});
watch(seleccion, () => {
  dimensionandingLineas();
  graficaLineas();
});

function reescalanding() {
  dimensionandingLineas();
  graficaLineas();
}
function dimensionandingLineas() {
  ancho.value =
    contenedor_svg.value.clientWidth -
    margenes.value.derecha -
    margenes.value.izquierda;
  alto_svg.value = window.innerHeight * 0.75;

  alto.value = alto_svg.value - margenes.value.arriba - margenes.value.abajo;

  escalaX.value = d3
    .scaleTime()
    .domain([formatoTemporal.value(2015), formatoTemporal.value(2023)])
    .range([0, ancho.value]);

  escalaY.value = d3.scaleLinear().domain([0, 55]).range([alto.value, 0]);

  eje_X.value.call(d3.axisBottom(escalaX.value));
  eje_Y.value.call(d3.axisLeft(escalaY.value));

  texto_x.value
    .attr(
      "x",
      (ancho.value + margenes.value.izquierda + margenes.value.derecha) / 2
    )
    .attr("y", alto.value + margenes.value.arriba + margenes.value.abajo - 2)
    .attr("font-size", "14")
    .attr("font-family", "Avenir, Helvetica, Arial, sans-serif")
    .attr("font-weight", "bold")
    .text("Año");

  texto_y.value
    .attr("transform", "rotate(-90)")
    .attr("y", 15)
    .attr("x", -(alto.value + margenes.value.arriba + margenes.value.abajo) / 2)
    .attr("font-size", "14")
    .attr("font-weight", "bold")
    .attr("font-family", "Avenir, Helvetica, Arial, sans-serif")
    .text("Tasa por cada 100 mil");
}

function graficaLineas() {
  // Primero agregamos las líneas
  grupo_lineas.value
    .selectAll("path")
    .data(data.value)
    .join(
      (enter) => {
        enter
          .append("path")
          .attr("stroke", (d) => set_color(d.key))
          .attr("stroke-width", 2.5)
          .attr("fill", "none")
          .attr("opacity", (d) => {
            if (d.key == "Nacional") {
              return 1;
            } else if (d.key == seleccion.value) {
              return 1;
            } else {
              return 0.4;
            }
          })
          .attr("d", (d) => {
            return d3
              .line()
              .x((d) => escalaX.value(formatoTemporal.value(d.anio)))
              .y((d) => escalaY.value(d.numero))(d.values);
          });
      },
      (update) => {
        update
          .transition()
          .attr("stroke", (d) => set_color(d.key))
          .attr("stroke-width", 2.5)
          .attr("fill", "none")
          .attr("opacity", (d) => {
            if (d.key == "Nacional") {
              return 1;
            } else if (d.key == seleccion.value) {
              return 1;
            } else {
              return 0.4;
            }
          })
          .attr("d", (d) => {
            return d3
              .line()
              .x((d) => escalaX.value(formatoTemporal.value(d.anio)))
              .y((d) => escalaY.value(d.numero))(d.values);
          });
      },
      (exit) => {
        exit.remove();
      }
    );

  grupo_nombres.value
    .selectAll("text")
    .data(data.value)
    .join(
      (enter) => {
        enter
          .append("text")
          .attr("y", (d) => escalaY.value(d.values[8]["numero"]) - 12)
          .attr("x", (d) =>
            escalaX.value(formatoTemporal.value(d.values[8]["anio"]))
          )
          .attr("text-anchor", "end")
          .attr("font-size", "13")
          .attr("font-weight", "bold")
          .attr("fill", (d) => set_color(d.key))
          .text((d) => {
            if (d.key == "Nacional") {
              return d.key;
            } else if (d.key == seleccion.value) {
              return seleccion.value;
            } else {
              return "";
            }
          });
      },
      (update) => {
        update
          .transition()
          .attr("y", (d) => escalaY.value(d.values[8]["numero"]) - 12)
          .attr("x", (d) =>
            escalaX.value(formatoTemporal.value(d.values[8]["anio"]))
          )
          .attr("text-anchor", "end")
          .attr("font-size", "13")
          .attr("font-weight", "bold")
          .attr("fill", (d) => set_color(d.key))
          .text((d) => {
            if (d.key == "Nacional") {
              return d.key;
            } else if (d.key == seleccion.value) {
              return seleccion.value;
            } else {
              return "";
            }
          });
      },
      (exit) => {
        exit.remove();
      }
    );
}

function set_color(x) {
  if (x == "Nacional") {
    return color_dict.value["nacional"];
  } else if (x == seleccion.value) {
    return color_dict.value[seleccion.value];
  } else {
    return color_dict.value["normal"];
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contenedor-general {
  /*background-color: pink;*/
  max-width: 1200px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: auto;
  padding: 5px;
}

.grafico {
  width: 100%;
  margin: 0px;
  /*background-color: orange;*/
}

.bullets {
  position: absolute;
  left: 30%;
  z-index: 1;
  width: 40%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  /*background-color: pink;*/
}

.bullet {
  /*background-color: blue;*/
  height: 94.5%;
  margin: 10px;
  padding: 0px;
  display: flex;
  align-items: center;
  /*opacity: 0;*/
  /*transition: all 1.5s ease-in-out;*/
}

.bullet.visible {
  opacity: 1;
}

.inner-bullet {
  padding: 10px;
  background-color: #f7f6f6;
  border-radius: 15px;
  /*opacity: 80%;*/
}

.highlight-colima {
  color: #d82b1e;
  font-weight: bold;
}

.highlight-bajacalifornia {
  color: #03244e;
  font-weight: bold;
}

.highlight-morelos {
  color: #6645aa;
  font-weight: bold;
}
@media (max-width: 850px) {
  .bullets {
    left: 0%;
    width: 100%;
  }
}
</style>
